import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';
import { Button } from './Button';
import { closeOnlyByButtons } from './dialogGuards';

interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Subtitle 16/B 가운데 정렬 */
  title: string;
  confirmLabel: string;
  cancelLabel?: string;
  onConfirm: () => void;
}

/**
 * Figma Pop-Up — 328px 흰 카드(radius 40 · 1.5px grey-100) + 취소/확인 버튼.
 * 로그아웃처럼 되돌리기 어려운 동작 전에 한 번 묻는다.
 */
export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  confirmLabel,
  cancelLabel = '취소',
  onConfirm,
}: ConfirmDialogProps) {
  return (
    <AlertDialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <AlertDialogPrimitive.Portal>
        <AlertDialogPrimitive.Overlay className="fixed inset-0 z-50 bg-dim" />
        <AlertDialogPrimitive.Content
          {...closeOnlyByButtons}
          aria-describedby={undefined}
          className="fixed top-1/2 left-1/2 z-50 flex w-[328px] max-w-[calc(100vw-32px)] -translate-x-1/2 -translate-y-1/2 flex-col gap-6 rounded-40 border-[1.5px] border-grey-100 bg-surface-white px-6 py-10 outline-none"
        >
          <AlertDialogPrimitive.Title className="text-center text-subtitle-16 font-bold text-fg-primary">
            {title}
          </AlertDialogPrimitive.Title>
          <div className="flex gap-2">
            <AlertDialogPrimitive.Cancel asChild>
              <Button variant="secondary" size="md" className="flex-1">
                {cancelLabel}
              </Button>
            </AlertDialogPrimitive.Cancel>
            <AlertDialogPrimitive.Action asChild>
              <Button size="md" className="flex-1" onClick={onConfirm}>
                {confirmLabel}
              </Button>
            </AlertDialogPrimitive.Action>
          </div>
        </AlertDialogPrimitive.Content>
      </AlertDialogPrimitive.Portal>
    </AlertDialogPrimitive.Root>
  );
}
